import * as React from 'react';
import { SVGProps } from 'react';

const IconTopSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.59 5.58L20 12l-8-8-8 8Z" />
  </svg>
);
export default IconTopSizeM;
